// Pinned renderer grammar: {{[a-z][a-z0-9_]*}} — lowercase-first, no
// whitespace tolerance. Must stay in lockstep with the backend renderer;
// anything looser here lets bodies through that the renderer will not fill.
const TOKEN_RE = /\{\{([a-z][a-z0-9_]*)\}\}/g
const VALID_AT_START_RE = /^\{\{[a-z][a-z0-9_]*\}\}/

export const findUnknownTokens = (
  body: string,
  allowed: string[]
): string[] => {
  const found = [...body.matchAll(TOKEN_RE)].map(m => m[1])
  return [...new Set(found.filter(t => !allowed.includes(t)))]
}

// Every `{{`-introduced fragment that is NOT a valid pinned token: spaced
// ({{ name }}), non-grammar ({{כתובת}}, {{Name}}) or unclosed ({{name).
// These would reach recipients as literal braces — surface them so the UI
// can block instead of silently sending garbage.
export const findMalformedPlaceholders = (body: string): string[] => {
  const malformed: string[] = []
  let i = body.indexOf('{{')
  while (i !== -1) {
    const rest = body.slice(i)
    const valid = VALID_AT_START_RE.exec(rest)
    if (valid) {
      i = body.indexOf('{{', i + valid[0].length)
      continue
    }
    const close = rest.indexOf('}}', 2)
    malformed.push(close === -1 ? rest : rest.slice(0, close + 2))
    // advance past the opener only, so a valid token inside the fragment
    // is still recognized on the next iteration
    i = body.indexOf('{{', i + 2)
  }
  return [...new Set(malformed)]
}

export const insertAtCursor = (
  body: string,
  pos: number,
  token: string
): { next: string; caret: number } => {
  const insert = `{{${token}}}`
  const next = body.slice(0, pos) + insert + body.slice(pos)
  return { next, caret: pos + insert.length }
}
